import React from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';

import App from './components/app';
import './styles/main.scss';

smoothscroll.polyfill();

ReactDOM.render(<App />, document.querySelector('.app'));
